/* ==========================================================================
   prinsert-quick-cart.js
   --------------------------------------------------------------------------
   Produktkacheln: Klick aufs Bild, Warenkorb-Knopf, Variantenauswahl.

   DREI FAELLE BEIM WARENKORB-KNOPF:

     Keine Varianten
       Ein Klick legt den Artikel in den Warenkorb.

     Genau eine Farboption (im Admin mit dem Farb-Metaobjekt verknuepft)
       Die Farbpunkte stehen bereits in der Kachel. Ein Klick waehlt die
       Farbe aus, der Warenkorb-Knopf legt dann genau diese Variante ab.

     Alles andere (Sets, Mengen, zwei Optionsebenen)
       Klick auf den Knopf oeffnet die Auswahlliste ueber der Kachel.

   ==========================================================================
   FRUEHERE FEHLER, die hier behoben sind -- bitte nicht zurueckbauen:

   1. Die Anzahl wurde in JEDEN Textknoten der Zaehler-Blase geschrieben.
      Aus einer 2 wurde dadurch eine 12.

   2. Es wurde nur die Zahl aktualisiert, nicht der Warenkorb selbst.

   3. QUELLE UND ZIEL SIND NICHT DERSELBE SELEKTOR: Die Section Rendering
      API liefert die Sektion samt Wrapper (.shopify-section). Beim
      Warenkorb-Symbol steckt der Inhalt darin, das Ziel #cart-icon-bubble
      ist aber das <a> im Header und kommt im gelieferten HTML nicht vor.

   4. ERSETZTES MARKUP VERLIERT SEINE HANDLER: Beim Ersetzen von #CartDrawer
      wird auch das Overlay getauscht -- der Warenkorb liess sich danach
      nicht mehr durch Klick daneben schliessen.

   5. ZWEI .card__information JE KACHEL -- siehe verschiebeKnoepfe().
   ========================================================================== */

(function () {
  if (window.__prinsertQuickCartInit) return;
  window.__prinsertQuickCartInit = true;

  var BRAUCHT_RUECKSPRACHE = ['wunschfarbe', 'wunschfarben'];
  var KNOPF_TEXT = 'In meinen Warenkorb';

  var produktCache = {};
  var offenesPopover = null;
  var knopfLauf = null;

  var CART_TEILE = [
    { section: 'cart-icon-bubble', quelle: '.shopify-section', ziel: '#cart-icon-bubble' },
    { section: 'cart-drawer', quelle: '#CartDrawer', ziel: '#CartDrawer' }
  ];

  var SECTION_NAMEN = CART_TEILE.map(function (teil) {
    return teil.section;
  });

  /* ------------------------------------------------------------------
     WARENKORB-KNOPF AUS DEM BILD NEBEN DEN PREIS VERSCHIEBEN

     Im Markup von snippets/card-product.liquid liegt der Knopf im
     Bildbereich. .card__media ist dort mit position: absolute ein eigener
     Bezugsrahmen -- per CSS ist die Stelle neben dem Preis nicht
     erreichbar, das Element muss umziehen.

     ZIEL IST DAS PREIS-ELEMENT SELBST:
     Der Knopf liegt absolut und richtet sich am naechsten positionierten
     Vorfahren aus. Erst als Kind von .price laesst sich "auf Hoehe des
     Preises" ueberhaupt ausdruecken.

     Dass die Knoepfe trotz Farbpunkten alle auf gleicher Hoehe sitzen,
     regelt prinsert-cards.css Abschnitt 2: Dort stehen die Farbpunkte per
     order: -1 UEBER dem Preis, wodurch die Preiszeile auf jeder Kachel
     die unterste ist.

     ACHTUNG -- ES GIBT ZWEI .card__information JE KACHEL:
       1. innerhalb von .card__inner im Bildbereich, mit der versteckten
          Ueberschrift fuer Kacheln ohne Bild -- praktisch leer
       2. darunter im zweiten .card__content, mit Spielname, Titel, Preis
          und Farbpunkten

     Ein einfaches querySelector('.card__information') liefert das ERSTE
     und damit den unsichtbaren Container -- der Knopf war danach spurlos
     verschwunden.

     WIEDERHOLUNG NOETIG: Kacheln kommen nach, wenn Slider nachladen oder
     eine Sektion neu gerendert wird. Der Beobachter setzt deshalb nach
     jeder DOM-Aenderung erneut an; die Funktion prueft vorher, ob der
     Knopf schon am Ziel ist, sonst entstuende eine Schleife.
     ------------------------------------------------------------------ */
  function preiszeileVon(wrapper) {
    var kandidaten = wrapper.querySelectorAll('.card__information');
    for (var i = 0; i < kandidaten.length; i++) {
      if (kandidaten[i].querySelector('.card-information, .price')) return kandidaten[i];
    }
    return null;
  }

  function verschiebeKnoepfe() {
    document.querySelectorAll('.card__quick-cart-icon').forEach(function (btn) {
      var wrapper = btn.closest('.card-wrapper') || btn.closest('.product-card-wrapper');
      if (!wrapper) return;

      /* Die Beschriftung steht schon im Markup (aria-label uebernimmt die
         Ansage fuer Screenreader), hier wird nur der sichtbare Text
         gesetzt. Dawns Uebersetzung lautet "In den Warenkorb". */
      var label = btn.querySelector('.card__quick-cart-icon-label');
      if (label && label.textContent !== KNOPF_TEXT) label.textContent = KNOPF_TEXT;

      var spalte = preiszeileVon(wrapper);
      if (!spalte) return;

      // Preis bevorzugt, Spalte als Rueckfallebene (Kacheln ohne Preis).
      var ziel = spalte.querySelector('.price') || spalte;
      if (btn.parentElement === ziel) return;

      ziel.appendChild(btn);
    });
  }

  function beobachteKacheln() {
    verschiebeKnoepfe();

    var observer = new MutationObserver(function () {
      if (knopfLauf) return;
      knopfLauf = window.requestAnimationFrame(function () {
        knopfLauf = null;
        verschiebeKnoepfe();
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function verdrahteSchliessen() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.close !== 'function') return;

    var overlay = drawer.querySelector('#CartDrawer-Overlay');
    if (overlay && !overlay.__prinsertBound) {
      overlay.__prinsertBound = true;
      overlay.addEventListener('click', function () {
        drawer.close();
      });
    }

    drawer.querySelectorAll('.drawer__close').forEach(function (btn) {
      if (btn.__prinsertBound) return;
      btn.__prinsertBound = true;
      btn.addEventListener('click', function () {
        drawer.close();
      });
    });
  }

  function aktualisiereWarenkorb(sections) {
    if (!sections) return;

    CART_TEILE.forEach(function (teil) {
      var html = sections[teil.section];
      if (!html) return;

      var dokument = new DOMParser().parseFromString(html, 'text/html');
      var neu = dokument.querySelector(teil.quelle) || dokument.body;
      var alt = document.querySelector(teil.ziel);
      if (neu && alt) alt.innerHTML = neu.innerHTML;
    });

    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.remove('is-empty');

    var items = document.querySelector('cart-drawer-items');
    if (items) items.classList.remove('is-empty');

    verdrahteSchliessen();
  }

  function flyToCart(originEl) {
    var cartIcon = document.querySelector('.header__icon--cart');
    if (!cartIcon || !originEl) return;

    var originRect = originEl.getBoundingClientRect();
    var badge = document.createElement('div');
    badge.className = 'card__fly-badge';
    badge.textContent = '+1';
    document.body.appendChild(badge);

    var halfW = badge.offsetWidth / 2;
    var halfH = badge.offsetHeight / 2;
    var startX = originRect.left + originRect.width / 2 - halfW;
    var startY = originRect.top + originRect.height / 2 - halfH;
    badge.style.left = startX + 'px';
    badge.style.top = startY + 'px';
    badge.style.transform = 'translate(0px, 0px) scale(0)';

    var targetRect = cartIcon.getBoundingClientRect();
    var dx = targetRect.left + targetRect.width / 2 - (startX + halfW);
    var dy = targetRect.top + targetRect.height / 2 - (startY + halfH);

    requestAnimationFrame(function () {
      badge.style.transition = 'transform 0.22s cubic-bezier(.34,1.56,.64,1)';
      badge.style.transform = 'translate(0px, 0px) scale(1.15)';
    });

    setTimeout(function () {
      badge.style.transition = 'transform 0.55s cubic-bezier(.5,-0.3,.6,1), opacity 0.2s ease 0.4s';
      badge.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(0.4)';
      badge.classList.add('is-flying');
    }, 220);

    setTimeout(function () {
      badge.remove();
    }, 900);
  }

  function legeInWarenkorb(variantId, btn) {
    btn.disabled = true;
    btn.classList.add('is-loading');

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: SECTION_NAMEN,
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        btn.classList.remove('is-loading');

        // Shopify meldet Fehler ueber ein status-Feld, nicht ueber HTTP-Codes.
        if (data && data.status) {
          btn.disabled = false;
          return;
        }

        btn.classList.add('is-added');
        flyToCart(btn);
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 1600);

        aktualisiereWarenkorb(data.sections);

        setTimeout(function () {
          document.dispatchEvent(new CustomEvent('prinsert:cart-added', { bubbles: true }));
        }, 700);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
  }

  function produktUrlAus(wrapper) {
    var link = wrapper.querySelector('.card__heading a[href], a[href*="/products/"]');
    return link ? link.getAttribute('href') : null;
  }

  function produktHandleAus(wrapper) {
    var href = produktUrlAus(wrapper) || '';
    var treffer = href.match(/\/products\/([^/?#]+)/);
    return treffer ? treffer[1] : null;
  }

  function ladeProdukt(handle) {
    if (produktCache[handle]) return Promise.resolve(produktCache[handle]);

    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (produkt) {
        produktCache[handle] = produkt;
        return produkt;
      });
  }

  function preis(cent) {
    return (cent / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac';
  }

  function brauchtRuecksprache(text) {
    return BRAUCHT_RUECKSPRACHE.indexOf(String(text).toLowerCase()) !== -1;
  }

  function schliessePopover() {
    if (!offenesPopover) return;
    offenesPopover.remove();
    offenesPopover = null;
  }

  function oeffnePopover(wrapper, btn, produkt) {
    schliessePopover();

    var pop = document.createElement('div');
    pop.className = 'prinsert-varipop';

    var titel = document.createElement('p');
    titel.className = 'prinsert-varipop__title';
    titel.textContent = 'Auswahl treffen';
    pop.appendChild(titel);

    var liste = document.createElement('div');
    liste.className = 'prinsert-varipop__list';

    produkt.variants.forEach(function (variante) {
      var zeile = document.createElement('button');
      zeile.type = 'button';
      zeile.className = 'prinsert-varipop__option';

      var name = document.createElement('span');
      name.className = 'prinsert-varipop__option-name';
      name.textContent = variante.title;

      var wert = document.createElement('span');
      wert.className = 'prinsert-varipop__option-price';

      var wunsch = (variante.options || []).some(brauchtRuecksprache);

      if (!variante.available) {
        zeile.disabled = true;
        zeile.classList.add('is-unavailable');
        wert.textContent = 'Ausverkauft';
      } else if (wunsch) {
        zeile.disabled = true;
        zeile.classList.add('is-needs-page');
        wert.textContent = 'nur auf Produktseite';
      } else {
        wert.textContent = preis(variante.price);
        zeile.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          schliessePopover();
          legeInWarenkorb(variante.id, btn);
        });
      }

      zeile.appendChild(name);
      zeile.appendChild(wert);
      liste.appendChild(zeile);
    });

    pop.appendChild(liste);

    var details = document.createElement('a');
    details.className = 'prinsert-varipop__details';
    details.href = '/products/' + produkt.handle;
    details.textContent = 'Alle Details ansehen';
    pop.appendChild(details);

    pop.addEventListener('click', function (ev) {
      ev.stopPropagation();
    });

    wrapper.appendChild(pop);
    offenesPopover = pop;
  }

  /* ------------------------------------------------------------------
     KLICK AUF DAS PRODUKTBILD OEFFNET DIE PRODUKTSEITE

     Ueber dem Bild liegt im Markup ein leerer Link (.card__media-link).
     In component-card.css gibt es dafuer KEINE EINZIGE REGEL -- er wurde
     nie positioniert. Ihn per CSS auf die volle Flaeche zu setzen half
     nicht: .card__media macht mit position: absolute und z-index: 0 einen
     eigenen Stapelkontext auf.
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    // Elemente mit eigenem Ziel haben Vorrang.
    if (
      e.target.closest(
        '.card__quick-cart-icon, .card__swatch, .prinsert-varipop, a[href], button, [role="button"]'
      )
    ) {
      return;
    }

    var wrapper = e.target.closest('.card-wrapper');
    if (!wrapper) return;

    var url = produktUrlAus(wrapper);
    if (!url) return;

    e.preventDefault();
    window.location.href = url;
  });

  /* ------------------------------------------------------------------
     Farbpunkte auf der Kachel: Auswahl merken.

     Der Punkt aendert nur die Markierung und die Varianten-ID am
     Warenkorb-Knopf. Bewusst NICHT direkt hinzufuegen -- sonst waere ein
     Vertippen auf der falschen Farbe sofort eine Bestellung.
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest && e.target.closest('.card__swatch');
    if (!swatch || swatch.disabled) return;

    e.preventDefault();
    e.stopPropagation();

    var wrapper = swatch.closest('.card-wrapper');
    if (!wrapper) return;

    wrapper.querySelectorAll('.card__swatch').forEach(function (s) {
      s.classList.toggle('is-active', s === swatch);
    });

    var cartBtn = wrapper.querySelector('.card__quick-cart-icon');
    if (cartBtn) {
      cartBtn.setAttribute('data-variant-id', swatch.getAttribute('data-variant-id'));
      cartBtn.setAttribute('data-variant-chosen', '1');
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.card__quick-cart-icon');

    if (!btn) {
      schliessePopover();
      return;
    }

    if (btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();

    var wrapper = btn.closest('.card-wrapper');
    if (!wrapper) return;

    // Zweiter Klick auf denselben Knopf schliesst eine offene Auswahl.
    if (offenesPopover && wrapper.contains(offenesPopover)) {
      schliessePopover();
      return;
    }

    /* Farbpunkte vorhanden -> die gewaehlte Variante steht schon fest.
       Bei "Wunschfarbe" fuehrt der Weg auf die Produktseite, weil dort das
       Kommentarfeld fuer die Farbwuensche liegt. */
    var aktiverSwatch = wrapper.querySelector('.card__swatch.is-active');
    if (aktiverSwatch) {
      if (brauchtRuecksprache(aktiverSwatch.getAttribute('data-value'))) {
        var ziel = produktUrlAus(wrapper);
        if (ziel) window.location.href = ziel;
        return;
      }
      legeInWarenkorb(aktiverSwatch.getAttribute('data-variant-id'), btn);
      return;
    }

    var handle = produktHandleAus(wrapper);
    if (!handle) {
      var fallbackId = btn.getAttribute('data-variant-id');
      if (fallbackId) legeInWarenkorb(fallbackId, btn);
      return;
    }

    btn.classList.add('is-loading');

    ladeProdukt(handle)
      .then(function (produkt) {
        btn.classList.remove('is-loading');

        if (!produkt || !produkt.variants || produkt.variants.length === 0) return;

        if (produkt.variants.length === 1) {
          legeInWarenkorb(produkt.variants[0].id, btn);
          return;
        }

        oeffnePopover(wrapper, btn, produkt);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
      });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') schliessePopover();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      verdrahteSchliessen();
      beobachteKacheln();
    });
  } else {
    verdrahteSchliessen();
    beobachteKacheln();
  }
})();
